import { type TabItem, Tabs, Typography, useMediaQuery } from "@kyan/ui";
import { AnimatePresence, motion } from "motion/react";

import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";
import { useTradePanelTab } from "#/store/app/tradePanel/tradePanelTab";
import { TradePanelTab } from "#/types/tradePanel";

import { ComboTab } from "./components/ComboTab/ComboTab";
import { OptionsTab } from "./components/OptionsTab/OptionsTab";
import { PerpsTab } from "./components/PerpsTab/PerpsTab";

const getTradePanelTabItems = (isSm: boolean): TabItem<TradePanelTab>[] => [
  {
    id: "options",
    label: "Options",
  },
  {
    id: "perps",
    label: "Perps",
  },
  ...(isSm
    ? [
        {
          id: "combo" as TradePanelTab,
          label: "Combo",
        },
      ]
    : []),
];

export const ContentWrapper: React.FC = () => {
  const { isSm } = useMediaQuery();
  const { showTradePanel } = useShowTradePanel();
  const { tradePanelTab, setTradePanelTab } = useTradePanelTab();

  const tradePanelTabItems = getTradePanelTabItems(isSm);

  const handleChangeTab = (id: TradePanelTab) => {
    setTradePanelTab(id);
  };
  return (
    <AnimatePresence>
      {showTradePanel ? (
        <motion.div
          exit={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="flex h-full flex-col"
        >
          {isSm && (
            <Typography grotesk semibold element="h3" className="px-4 py-4">
              Trade
            </Typography>
          )}
          <Tabs
            value={tradePanelTab}
            items={tradePanelTabItems}
            className="w-full flex-none"
            onChange={handleChangeTab}
          />
          <div className="flex-1 overflow-hidden">
            {tradePanelTab === "options" && <OptionsTab />}
            {tradePanelTab === "perps" && <PerpsTab />}
            {tradePanelTab === "combo" && <ComboTab />}
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
